import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import config from '@/common/config';
import auth from '@/common/auth/auth';

export default function getColumns({onRowEdit, onRowClone, onRowDelete}) {
    return new ColumnSet({
        id: 'checkout-pages-list',
        store,
        version: 5,
        defaultColumns: [
            {
                name: 'name',
                sticky: true,
            },
            {
                name: 'urlPathSegment',
                header: 'URL Path Segment',
            },
            {
                name: 'planId',
            },
            {
                name: 'websiteId',
            },
            {
                name: 'status',
                type: 'badge',
                map: BADGES_COLOR_MAP.status,
            },
            {
                name: 'createdTime',
                header: 'Creation Time',
                type: 'datetime',
            },
        ],
        lockedColumns: [
            {
                header: false,
                type: 'nested',
                style: {textRight: true},
                columns: [
                    {
                        type: 'button',
                        style: {
                            icon: 'clone',
                            tooltip: 'clone',
                        },
                        click: ({rowData}) => onRowClone({rowData}),
                        predicate: auth.$pages['update-checkout-page'].isAllowed,
                    },
                    {
                        type: 'button',
                        style: {
                            icon: 'external-link',
                            tooltip: 'preview',
                        },
                        click: ({rowData}) => {
                            const {VUE_APP_CHECKOUT_URL: baseUrl} = config;
                            window.open(`${baseUrl}/checkout/${rowData.fields.urlPathSegment}`, '_blank');
                        },
                    },
                    {
                        type: 'button',
                        style: {
                            preset: 'edit',
                            tooltip: 'edit',
                        },
                        enabled: () => true,
                        click: ({rowData}) => onRowEdit({rowData}),
                        predicate: auth.$pages['update-checkout-page'].isAllowed,
                    },
                    {
                        type: 'button',
                        style: {
                            preset: 'delete',
                            tooltip: 'delete',
                        },
                        enabled: () => true,
                        click: ({rowData, grid}) => onRowDelete({rowData, grid}),
                        predicate: auth.$pages['update-checkout-page'].isAllowed,
                    },
                ],
            },
        ],
    });
}
